var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiscalCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.825,
    height: 28.483,
    viewBox: "0 0 41.825 28.483",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_42_icn_credit_card",
    "data-name": "42_icn_credit_card",
    transform: "translate(0.9 0.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_20639",
    "data-name": "Tracciato 20639",
    d: "M37.69,1H4.335A3.337,3.337,0,0,0,1,4.335V24.348a3.337,3.337,0,0,0,3.335,3.335H37.69a3.337,3.337,0,0,0,3.335-3.335V4.335A3.337,3.337,0,0,0,37.69,1ZM1,12.677H41.026m0-5.007H1M6.634,18.059H22.68M6.634,21.394H17.678m11.674-3.335h5.64",
    transform: "translate(-1 -1)",
    fill: "white",
    stroke: "#0e5bc7",
    strokeWidth: 1.8
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiscalCode);
export default __webpack_public_path__ + "static/media/fiscalCode.cea67b1b0e67d819406c61d2170e3e91.svg";
export { ForwardRef as ReactComponent };